var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-active":_vm.$route.path,"collapse":_vm.collapse,"router":true}},_vm._l((_vm.menuList),function(menu){return _c('sidebar-item',{key:menu.id,attrs:{"item":menu,"collapse":_vm.collapse}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }